// Лозунг со знаком «ф» на главной, витринах и странице «Как это работает».
import type { ReactNode } from "react";
import styles from "./Slogan.module.css";

// Знак — строчная «ф» между чертами, похожая на знак бесконечности. Заглавную «Ф» не ставим:
// в Unbounded она — овал с палкой (макет, версия 53).
const MARK_LETTER = "ф";

// Лозунг сервиса — на главной и в «Как это работает» (Иван, 24.10.2026): «ф» рядом —
// и бесконечность, и фантазия, и фигурка. Буквы в словах не подсвечиваем. Неразрывные
// пробелы — чтобы строка не начиналась с тире или с «твоей» без предлога.
export const MAIN_SLOGAN = "Бесконечная фантазия\u00a0— в\u00a0твоей фигурке";

// Лозунг строкой над кнопкой «Создать фигурку» на витринах: «ф» цвета направления.
export function SloganLine({ title }: { title: string }) {
  return (
    <div className={styles.line}>
      <span className={`${styles.phi} ${styles.phiSmall}`} aria-hidden="true">
        {MARK_LETTER}
      </span>
      <p className={styles.lineTitle}>{title}</p>
    </div>
  );
}

export function Slogan({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <section className={[styles.slogan, children === undefined ? styles.short : ""].join(" ")} aria-label={title}>
      <span className={styles.phi} aria-hidden="true">
        {MARK_LETTER}
      </span>
      <p className={styles.title}>{title}</p>
      {children !== undefined && <p className={styles.text}>{children}</p>}
    </section>
  );
}
